import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    subId = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.orgGroupConfig.getKpiConfig, {
        subId,
    }, options);
    if (error) return { error, status };
    return content || { };
};
